import { Subscription } from 'rxjs';

export function safelyUnSubScribe(maybeSubs: Subscription[]): void {
  maybeSubs.forEach((maybeSub) => {
    if (maybeSub) {
      maybeSub.unsubscribe();
    }
  });
}
